import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const DeliveryConfirmationWizardRoute: RouteType = {
  name: "DeliveryConfirmationWizard",
  path: "/workflows/delivery-confirmation",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Delivery Confirmation & POD Upload",
      component: () => import("./DeliveryConfirmationWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./DeliveryConfirmationWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const loadStore = rootStore.loadStore as ServiceStore;
      const documentManagementStore = rootStore.documentManagementStore as ServiceStore;
      const azureBlobStorageStore = rootStore.azureBlobStorageStore as ServiceStore;
      const invoicesStore = rootStore.invoicesStore as ServiceStore;

      await Promise.all([
        loadStore?.find(),
        documentManagementStore?.find(),
        azureBlobStorageStore?.find(),
        invoicesStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for delivery confirmation:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).deliveryConfirmationWizardStore;
    store?.reset();
  },
};

export default DeliveryConfirmationWizardRoute;